<div class="col">
    <mat-table 
        *ngIf="canShowTable; else noMatchesTemplate"
        matSort 
        [dataSource]="dataSource" 
        class="mat-table-container">
        <ng-container 
            matColumnDef="{{column}}" 
            *ngFor="let column of allColumns">

            <ng-container>
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{getColumnTitle(column)}}
                </mat-header-cell>
            </ng-container>

            <mat-header-cell *matHeaderCellDef>
                {{getColumnTitle(column)}}
            </mat-header-cell>

            <mat-cell class="mat-cell-value" *matCellDef="let item">
                <ng-container
                    [ngTemplateOutlet]="columnContent"
                    [ngTemplateOutletContext]="{item: item, column: column}">
                </ng-container>
            </mat-cell>
            
        </ng-container>

        <mat-header-row *matHeaderRowDef="allColumns; sticky: true"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: allColumns; let entry"
            class="element-row">
        </mat-row>
    </mat-table>
</div>

<mat-paginator 
    [pageSizeOptions]="[10, 25, 50]" 
    showFirstLastButtons>
</mat-paginator>

<mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
        <button mat-menu-item
            (click)="onEditUser(item)">
            <mat-icon>edit</mat-icon>
            Edit
        </button>

        <button mat-menu-item
            *ngIf="item.IsDisabled"
            (click)="onEnableUser(item, 'Enable')">
            <mat-icon>power</mat-icon>
            Enable
        </button>

        <button mat-menu-item
            *ngIf="!item.IsDisabled"
            (click)="onDisableUser(item,'Disable')">
            <mat-icon>power_off</mat-icon>
            Disable
        </button>
    </ng-template>
</mat-menu>

<ng-template #noMatchesTemplate>
    <app-empty-list-holder
        [icon]="'search'"
        [description]="'No matches'">
    </app-empty-list-holder>
</ng-template>

<ng-template #columnContent let-item="item" let-column="column">
    <ng-container [ngSwitch]="column">
        <span *ngSwitchDefault>
            {{ item[column] }}
        </span>

        <span *ngSwitchCase="'IsDisabled'">
            <i *ngIf="!item[column]"
                class="pi pi-circle-on active-icon"
            ></i>

            <i *ngIf="item[column]"
                class="pi pi-circle-off disabled-icon"
            ></i>
        </span>

        <ng-container *appUserRoleUp="[ Role.Admin ]">
            <ng-container *ngIf="item?.ID > 0">
                <button *ngSwitchCase="'Menu'"
                    mat-button
                    class="menu-button pull-left"
                    (click)="$event.preventDefault()"
                    [matMenuTriggerFor]="menu"
                    [matMenuTriggerData]="{item: item}">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>